(function () {
  'use strict';

  var allowedFiles = {
    image: ['jpg', 'jpeg', 'png', 'webp'],
    invoice: ['pdf', 'jpg', 'jpeg', 'png'],
    video: ['mp4', 'mov', 'webm']
  };
  var GENERIC_VERIFY_ERROR = "We couldn't verify your order right now. Please try again shortly or contact Lukzer Care.";
  var GENERIC_REGISTER_ERROR = "We couldn't register your warranty right now. Please try again shortly or contact Lukzer Care.";
  var GENERIC_CLAIM_ERROR = "We couldn't submit your warranty request right now. Please try again shortly or contact Lukzer Care.";
  var GENERIC_TRACK_ERROR = "We couldn't check your claim right now. Please try again shortly or contact Lukzer Care.";
  var SUPABASE_REGISTRATION_URL = 'https://pketeqfoijehknxtkclx.supabase.co/rest/v1/rpc/register_warranty';
  var SUPABASE_ANON_KEY = 'sb_publishable_G8QzOI4ZtlPC5MKQ5ihsoA_mS9tbZu_';

  function jsonRequest(payload) {
    return {
      method: 'POST',
      body: JSON.stringify(payload || {}),
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    };
  }

  function postForm(form) {
    return {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    };
  }

  function fieldValue(form, name) {
    var field = form.elements[name];
    return field ? String(field.value || '').trim() : '';
  }

  function getCommonPayload(form) {
    return {
      fullName: fieldValue(form, 'full_name'),
      email: fieldValue(form, 'email'),
      mobile: fieldValue(form, 'mobile'),
      orderId: fieldValue(form, 'order_id'),
      modelNumber: fieldValue(form, 'model_number'),
      purchaseSource: fieldValue(form, 'purchase_source'),
      purchaseDate: fieldValue(form, 'purchase_date'),
      invoiceNumber: fieldValue(form, 'invoice_number')
    };
  }

  function getSupabaseRegistrationPayload(form) {
    var common = getCommonPayload(form);
    return {
      p_full_name: common.fullName,
      p_email: common.email,
      p_mobile: common.mobile,
      p_order_id: common.orderId,
      p_model_number: common.modelNumber,
      p_purchase_source: common.purchaseSource,
      p_purchase_date: common.purchaseDate,
      p_invoice_number: common.invoiceNumber
    };
  }

  function supabaseRegistrationRequest(form) {
    return {
      method: 'POST',
      body: JSON.stringify(getSupabaseRegistrationPayload(form)),
      credentials: 'omit',
      headers: {
        apikey: SUPABASE_ANON_KEY,
        Authorization: 'Bearer ' + SUPABASE_ANON_KEY,
        'Content-Type': 'application/json'
      }
    };
  }

  function postClaimForm(form) {
    var payload = new FormData();
    var common = getCommonPayload(form);
    Object.keys(common).forEach(function (key) {
      payload.append(key, common[key]);
    });
    payload.append('issueType', fieldValue(form, 'issue_type'));
    payload.append('issueDescription', fieldValue(form, 'issue_description'));

    ['product_photos', 'video'].forEach(function (name) {
      var input = form.elements[name];
      Array.prototype.forEach.call(input && input.files ? input.files : [], function (file) {
        payload.append('attachments', file, file.name);
      });
    });
    Array.prototype.forEach.call(form.elements.invoice && form.elements.invoice.files ? form.elements.invoice.files : [], function (file) {
      payload.append('invoice', file, file.name);
    });

    return {
      method: 'POST',
      body: payload,
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    };
  }

  function request(endpoint, options, fallbackMessage) {
    if (!endpoint) {
      return Promise.resolve({ ok: false, placeholder: true, message: fallbackMessage || GENERIC_VERIFY_ERROR });
    }

    return fetch(endpoint, options).then(function (response) {
      return response.json().catch(function () {
        return { success: response.ok };
      }).then(function (body) {
        if (!response.ok) return body;
        return body;
      });
    }).catch(function () {
      if (window.console && window.console.info) {
        window.console.info('[LukzerWarranty] Service unavailable or not configured yet.');
      }
      return { ok: false, placeholder: true, message: fallbackMessage || GENERIC_VERIFY_ERROR };
    });
  }

  var LukzerWarrantyAPI = {
    registerWarranty: function (form) {
      return request(SUPABASE_REGISTRATION_URL, supabaseRegistrationRequest(form), GENERIC_REGISTER_ERROR).then(function (result) {
        if (Array.isArray(result)) return { success: true, registration: result[0] || {} };
        return result;
      });
    },
    submitClaim: function (form) { return request(form.dataset.serviceSubmit, postClaimForm(form), GENERIC_CLAIM_ERROR); },
    trackClaim: function (form) { return request(form.dataset.serviceStatus, postForm(form), GENERIC_TRACK_ERROR); }
  };

  function setLoading(button, loading, fallbackText) {
    if (!button) return;
    if (loading) {
      button.dataset.originalText = button.textContent;
      button.textContent = button.dataset.loadingLabel || fallbackText || 'Please wait...';
      button.disabled = true;
    } else {
      button.textContent = button.dataset.originalText || button.textContent;
      button.disabled = false;
    }
  }

  function setMessage(root, text, type) {
    var message = root.querySelector('[data-lukzer-message]');
    if (!message) return;
    message.textContent = text || '';
    message.classList.toggle('is-error', type === 'error');
    message.classList.toggle('is-success', type === 'success');
  }

  function formatWarrantyDate(value) {
    if (!value) return '';
    var parts = String(value).split('-');
    if (parts.length !== 3) return String(value);
    var date = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  }

  function registrationSuccessMessage(registration) {
    if (registration && registration.warranty_expiry) {
      return 'Your Lukzer product is covered under warranty until ' + formatWarrantyDate(registration.warranty_expiry) + '.';
    }
    if (registration && registration.warranty_months === 0) {
      return 'This product does not include a warranty.';
    }
    return "We couldn't automatically confirm the warranty for this model — our team will verify and get back to you.";
  }

  function visibleFieldsValid(root) {
    var fields = Array.prototype.slice.call(root.querySelectorAll('input, select, textarea')).filter(function (field) {
      return !field.disabled && !field.closest('[hidden]') && field.type !== 'hidden';
    });
    return fields.every(function (field) {
      var message = field.dataset.validationMessage || 'Please complete this field.';
      field.setCustomValidity('');

      if (field.matches('[data-lukzer-mobile-10]') && !validIndianMobile(field)) {
        field.setCustomValidity(message);
        field.reportValidity();
        return false;
      }

      if (field.type === 'email' && field.value.trim() && !field.checkValidity()) {
        field.setCustomValidity(message);
        field.reportValidity();
        return false;
      }

      if (field.hasAttribute('required') && !field.value.trim()) {
        field.setCustomValidity(message);
        field.reportValidity();
        return false;
      }

      return field.reportValidity();
    });
  }

  function validIndianMobile(field) {
    var value = field.value.replace(/\D/g, '').slice(0, 10);
    field.value = value;
    return value.length === 10;
  }

  function initMobileValidation(root) {
    root.addEventListener('input', function (event) {
      if (!event.target.matches('[data-lukzer-mobile-10]')) return;
      event.target.value = event.target.value.replace(/\D/g, '').slice(0, 10);
      event.target.setCustomValidity('');
    });
  }

  function initRegister(form) {
    initMobileValidation(form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!visibleFieldsValid(form)) return;
      var button = event.submitter || form.querySelector('button[type="submit"]');
      var success = form.querySelector('[data-lukzer-register-success]');
      setLoading(button, true);
      LukzerWarrantyAPI.registerWarranty(form).then(function (result) {
        if (result && (result.success || result.ok)) {
          if (success) success.hidden = false;
          var registration = result.registration || {};
          var registrationId = form.querySelector('[data-lukzer-registration-id]');
          if (registrationId) registrationId.textContent = registration.id || result.registrationId || 'Provided after submission';
          setMessage(form, registrationSuccessMessage(registration), 'success');
        } else {
          if (success) success.hidden = true;
          setMessage(form, result.message || GENERIC_REGISTER_ERROR, 'error');
        }
      }).finally(function () {
        setLoading(button, false);
      });
    });
  }

  function initClaim(form) {
    initMobileValidation(form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!visibleFieldsValid(form)) return;
      var button = event.submitter || form.querySelector('button[type="submit"]');
      var success = form.querySelector('[data-lukzer-claim-success]');
      setLoading(button, true);
      LukzerWarrantyAPI.submitClaim(form).then(function (result) {
        if (result && (result.success || result.ok)) {
          if (success) success.hidden = false;
          var claimId = form.querySelector('[data-lukzer-claim-id]');
          var claimStatus = form.querySelector('[data-lukzer-claim-status]');
          if (claimId) claimId.textContent = result.claimId || 'Provided after submission';
          if (claimStatus) claimStatus.textContent = result.status || 'Request Received';
          setMessage(form, "We've received your request.", 'success');
        } else {
          if (success) success.hidden = true;
          setMessage(form, result.message || GENERIC_CLAIM_ERROR, 'error');
        }
      }).finally(function () {
        setLoading(button, false);
      });
    });
  }

  function initTrack(form) {
    initMobileValidation(form);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!visibleFieldsValid(form)) return;
      var button = event.submitter || form.querySelector('button[type="submit"]');
      var timeline = form.querySelector('[data-lukzer-timeline]');
      setLoading(button, true);
      LukzerWarrantyAPI.trackClaim(form).then(function (result) {
        if (result && (result.success || result.ok) && result.claim && timeline) {
          renderClaimResult(form, result.claim);
          timeline.hidden = false;
          Array.prototype.forEach.call(timeline.children, function (item, index) {
            var statuses = ['Request Received', 'Under Review', 'Need Customer Information', 'Technical Support', 'Replacement Approved', 'Replacement Dispatched', 'Resolved', 'Closed'];
            var currentIndex = statuses.indexOf(result.claim.currentStatus);
            item.classList.toggle('is-complete', index < currentIndex);
            item.classList.toggle('is-current', index === currentIndex);
          });
          setMessage(form, 'Current Status: ' + result.claim.currentStatus + '.', 'success');
        } else {
          if (timeline) timeline.hidden = true;
          renderClaimResult(form, null);
          setMessage(form, result.message || GENERIC_TRACK_ERROR, 'error');
        }
      }).finally(function () {
        setLoading(button, false);
      });
    });
  }

  function fileType(input) {
    var name = input.name.toLowerCase();
    if (name.indexOf('video') !== -1) return 'video';
    if (name.indexOf('invoice') !== -1) return 'invoice';
    return 'image';
  }

  function validateFiles(input) {
    var allowed = allowedFiles[fileType(input)];
    var files = Array.prototype.slice.call(input.files || []);
    var invalid = files.find(function (file) {
      var ext = file.name.split('.').pop().toLowerCase();
      return allowed.indexOf(ext) === -1;
    });
    return invalid ? 'Unsupported file type. Please upload ' + allowed.join(', ') + '.' : '';
  }

  function renderOrders(form, orders) {
    var results = form.querySelector('[data-lukzer-order-results]');
    var empty = form.querySelector('[data-lukzer-order-empty]');
    if (!results) return;
    results.textContent = '';
    if (!orders.length) {
      if (empty) {
        empty.hidden = false;
        empty.textContent = "We couldn't find an eligible Lukzer order for this number.";
      }
      return;
    }
    if (empty) empty.hidden = true;
    orders.forEach(function (order, index) {
      var label = document.createElement('label');
      label.className = 'lukzer-warranty-order';
      label.innerHTML = [
        '<input type="radio" name="selected_product" value="' + escapeAttr(order.variantId || order.productId || index) + '"' + (index === 0 ? ' required' : '') + '>',
        order.productImage ? '<img class="lukzer-warranty-order-image" src="' + escapeAttr(order.productImage) + '" alt="">' : '<span class="lukzer-warranty-order-image" aria-hidden="true"></span>',
        '<span><b>Product title</b><small>' + escapeHtml(order.productTitle) + '</small></span>',
        '<span><b>Order ID</b><small>' + escapeHtml(order.orderId) + '</small></span>',
        '<span><b>SKU</b><small>' + escapeHtml(order.sku) + '</small></span>',
        '<span><b>Variant</b><small>' + escapeHtml(order.variantTitle) + '</small></span>',
        '<span><b>Purchase date</b><small>' + escapeHtml((order.purchaseDate || '').slice(0, 10)) + '</small></span>',
        '<span><b>Quantity</b><small>' + escapeHtml(order.quantity) + '</small></span>'
      ].join('');
      results.appendChild(label);
    });
  }

  function renderClaimResult(form, claim) {
    var target = form.querySelector('[data-lukzer-claim-result]');
    if (!target) return;
    if (!claim) {
      target.hidden = true;
      target.textContent = '';
      return;
    }
    target.hidden = false;
    target.innerHTML = [
      '<h3>Claim Details</h3>',
      '<p><strong>Claim ID:</strong> ' + escapeHtml(claim.claimId) + '</p>',
      '<p><strong>Product:</strong> ' + escapeHtml(claim.product) + '</p>',
      '<p><strong>Date Created:</strong> ' + escapeHtml(claim.createdDate) + '</p>',
      '<p><strong>Last Updated:</strong> ' + escapeHtml(claim.lastUpdated) + '</p>',
      '<p><strong>Current Status:</strong> ' + escapeHtml(claim.currentStatus) + '</p>'
    ].join('');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function escapeAttr(value) {
    return escapeHtml(value).replace(/`/g, '&#96;');
  }

  function initFileFeedback(root) {
    root.addEventListener('change', function (event) {
      if (event.target.type !== 'file') return;
      var label = event.target.closest('label');
      if (!label) return;
      var existing = label.querySelector('[data-file-feedback]');
      if (!existing) {
        existing = document.createElement('span');
        existing.className = 'lukzer-warranty-file-feedback';
        existing.setAttribute('data-file-feedback', '');
        label.appendChild(existing);
      }
      existing.textContent = '';
      if (!event.target.files.length) return;

      var error = validateFiles(event.target);
      if (error) {
        event.target.value = '';
        existing.textContent = error;
        existing.classList.add('is-error');
        return;
      }
      existing.classList.remove('is-error');

      var file = event.target.files[0];
      var size = file && file.size ? ' (' + Math.ceil(file.size / 1024) + ' KB)' : '';
      var text = document.createElement('span');
      text.textContent = event.target.files.length === 1 ? file.name + size : event.target.files.length + ' files selected';
      var remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Remove';
      remove.addEventListener('click', function () {
        event.target.value = '';
        existing.textContent = '';
      });
      existing.appendChild(text);
      existing.appendChild(remove);
    });
  }

  function initAccordions(root) {
    Array.prototype.forEach.call(root.querySelectorAll('details'), function (detail) {
      var summary = detail.querySelector('summary');
      if (!summary) return;
      summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      detail.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      });
    });
  }

  function switchView(root, view, options) {
    options = options || {};
    var panelsWrap = root.querySelector('[data-lukzer-warranty-panels]');
    if (panelsWrap) panelsWrap.hidden = false;

    Array.prototype.forEach.call(root.querySelectorAll('[data-lukzer-warranty-view-button]'), function (button) {
      var active = button.getAttribute('data-lukzer-warranty-view-button') === view;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-lukzer-warranty-view]'), function (panel) {
      var active = panel.getAttribute('data-lukzer-warranty-view') === view;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
      if (active && options.scroll !== false) {
        scrollPanelIntoView(panel);
      }
    });

    if (options.syncUrl !== false && window.history && window.URLSearchParams) {
      var url = new URL(window.location.href);
      url.searchParams.set('tab', view);
      window.history.pushState({ lukzerWarrantyTab: view }, '', url.toString());
    }
  }

  function scrollPanelIntoView(panel) {
    var header = document.querySelector('.shopify-section-header-sticky, sticky-header, header[role="banner"], .site-header, .nov-header, #header');
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    var spacing = 26;
    var top = panel.getBoundingClientRect().top + window.pageYOffset - headerHeight - spacing;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
  }

  function openFromUrl(root) {
    var params = new URLSearchParams(window.location.search);
    var requested = params.get('tab');
    if (requested === 'claim' || requested === 'track' || requested === 'register' || requested === 'policy') {
      switchView(root, requested, { scroll: false, syncUrl: false });
    } else {
      var panelsWrap = root.querySelector('[data-lukzer-warranty-panels]');
      if (panelsWrap) panelsWrap.hidden = true;
      Array.prototype.forEach.call(root.querySelectorAll('[data-lukzer-warranty-view-button]'), function (button) {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-lukzer-warranty-view]'), function (panel) {
        panel.hidden = true;
        panel.classList.remove('is-active');
      });
    }
  }

  function initRoot(root) {
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-lukzer-warranty-view-button]');
      if (!button || !root.contains(button)) return;
      switchView(root, button.getAttribute('data-lukzer-warranty-view-button'));
    });

    initFileFeedback(root);
    openFromUrl(root);

    var register = root.querySelector('[data-lukzer-register-form]');
    var claim = root.querySelector('[data-lukzer-claim-form]');
    var track = root.querySelector('[data-lukzer-track-form]');
    if (register) initRegister(register);
    if (claim) initClaim(claim);
    if (track) initTrack(track);
    initAccordions(root);

    window.addEventListener('popstate', function () {
      openFromUrl(root);
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lukzer-warranty]'), initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.LukzerWarrantyAPI = LukzerWarrantyAPI;
  window.LukzerWarranty = {
    api: LukzerWarrantyAPI,
    switchView: switchView
  };
})();
